<template>
  <div>
    <el-row>
      <el-table
          v-loading="loading"
          :data="list"
          border
          size="mini"
          :stripe="true"
          style="width: 100%; margin: 20px 0"
      >
        <el-table-column
            prop="id"
            label="ID"
            align="center"
            min-width="18%"
        ></el-table-column>

        <el-table-column
            prop="type_name"
            label="类型"
            align="center"
            min-width="68%"
        ></el-table-column>

        <el-table-column label="操作" align="center" min-width="24%">
          <template slot-scope="{ row }">
            <el-button
                type="text"
                size="mini"
                @click="toRelationList(row.id)"
            >
              添加内容
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
            background
            @current-change="getList"
            :current-page.sync="query.page"
            :page-size="query.limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import {getList} from "@/api/searchRecommend";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    toRelationList(id) {
      this.$router.push({
        path: "/searchRecommend/relation/list",
        query: {
          id: id
        }
      });
    },

    getListQuery(){
      this.query.page = 1
      this.getList()
    },

    getList() {
      this.loading = true;
      getList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },
  },
  mounted() {

  },
};
</script>